// import logo from './logo.svg';
import "./App.css";

import React from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

import ImgMockup1 from "./assets/images/graph_electric_bath.png";
import ImgMockup2 from "./assets/images/table_electric_bath.png";
import ImgMockup3 from "./assets/images/graph_water_bath.png";
import ImgMockup4 from "./assets/images/table_water_bath.png";

function App() {
  //// Tab

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAL9-O0VLfVcUBGe_T979LADKw_TEo9bGU",
  });

  const [Tabs, setTabs] = React.useState([
    { name: "Main Area", enable: true, icon: "" },
    { name: "Zone", enable: true, icon: "" },
    { name: "Water", enable: true, icon: "" },
    { name: "Electric", enable: true, icon: "" },
    { name: "Road", enable: true, icon: "" },
  ]);
  const [TabSelected, setTabSelected] = React.useState(null);
  const [TabStack, setTabStack] = React.useState([""]);

  const onBackTab = () => {
    let backTabName = TabStack[TabStack.length - 2];
    setTabSelected(backTabName);
    let updateStackTab = [...TabStack];
    updateStackTab.pop();
    setTabStack(updateStackTab);

    panTo(mainAreaBoundaries[0].path);
  };

  const onNextTab = (tabName) => {
    if (
      tabName !== 2 &&
      tabName !== 3 &&
      tabName !== 4 &&
      tabName !== TabSelected
    ) {
      setTabSelected(tabName);
      let updateStackTab = [...TabStack];
      updateStackTab.push(tabName);
      setTabStack(updateStackTab);

      if (zoneSelected) {
        panTo(zoneSelected.path);
      } else {
        panTo(mainAreaBoundaries[0].path);
      }
    }
  };

  const [mainAreaBoundaries, setMainAreaBoundaries] = React.useState([
    {
      name: "Main Area",
      color: "yellow",
      path: [
        { name: 1, lat: 13.849134530056295, lng: 100.68308684013908 },
        { name: 2, lat: 13.849134530056295, lng: 100.68308684013908 },
        { name: 3, lat: 13.848805094038607, lng: 100.68292993092241 },
        { name: 4, lat: 13.848363675085206, lng: 100.68371179479705 },
        { name: 5, lat: 13.848790770722877, lng: 100.68382847088125 },
        { name: 6, lat: 13.848926191127044, lng: 100.68323167941604 },
        { name: 7, lat: 13.849000411892003, lng: 100.68309354566118 },
        { name: 8, lat: 13.849111091936082, lng: 100.68314718983783 },
      ],
    },
  ]);

  const [roadBoundaries, setRoadBoundaries] = React.useState([
    {
      name: "Main Road",
      color: "#129EAF",
      path: [
        { lat: 13.849217214526185, lng: 100.68317602356896 },
        { lat: 13.849120857827018, lng: 100.68311969717965 },
        { lat: 13.849008875667007, lng: 100.68305264195428 },
        { lat: 13.84893986337871, lng: 100.6831639536284 },
        { lat: 13.848868246831481, lng: 100.68328062972054 },
        { lat: 13.8487927239032, lng: 100.68339596470818 },
        { lat: 13.848741941230745, lng: 100.68348715981469 },
        { lat: 13.8487158988303, lng: 100.68357030829415 },
        { lat: 13.848682043705358, lng: 100.68371917089448 },
      ],
    },
  ]);

  const [zone, setZone] = React.useState([
    {
      name: "999/101",
      tenant: "นาย ชนม์พัศนภ พรรธน์ยศ",
      address: "999/124 ABC-Road, PHUTO 99999",
      idcard: "1923333339992",
      tel: "0899114064",
      email: "Jimmy.c@gmail.com",
      rentalperiod: "2 year",
      price: "12000",
      paymentdeadline: "30-02-2023",
      lastpayment: "28-02-2023",
      status: "paid",
      water: {
        name: "Water Meter 999/101",
        position: { lat: 13.84865683092764, lng: 100.68360531241356 },
        meter: 7563,
      },
      electric: {
        name: "Electric Meter 999/101",
        position: { lat: 13.848646702807594, lng: 100.6836660038713 },
        meter: 1023,
      },
      path: [
        { name: "", lat: 13.848660513880272, lng: 100.68358444972498 },
        { name: "", lat: 13.848637495425368, lng: 100.68367833182364 },
        { name: "", lat: 13.84840362779428, lng: 100.68361953697396 },
        { name: "", lat: 13.848463475832528, lng: 100.68353418961154 },
      ],
      doc: [
        {
          name: "สัญญาเช่า",
          url: "https://www.kanpho.go.th/new/images/formfood2/%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%87%E0%B8%AA%E0%B8%B7%E0%B8%AD%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B9%80%E0%B8%8A%E0%B9%88%E0%B8%B2_new.pdf",
        },
      ],
    },
    {
      name: "999/102",
      tenant: "นาย วรภพ ฉัตรเฉลิม",
      address: "999/124 ABC-Road, PHUTO 99999",
      idcard: "1923333339992",
      tel: "0899114064",
      email: "Jimmy.c@gmail.com",
      rentalperiod: "2 year",
      price: "12000",
      paymentdeadline: "30-02-2023",
      lastpayment: "28-02-2023",
      status: "paid",
      water: {
        name: "Water Meter 999/102",
        position: { lat: 13.848750110680717, lng: 100.68351062106491 },
        meter: 8956,
      },
      electric: {
        name: "Electric Meter 999/102",
        position: { lat: 13.84873318312169, lng: 100.68355890082388 },
        meter: 4023,
      },
      path: [
        { name: "", lat: 13.84876182975933, lng: 100.68347843455891 },
        { name: "", lat: 13.848735787361619, lng: 100.68360181616521 },
        { name: "", lat: 13.848842561173678, lng: 100.68362997935793 },
        { name: "", lat: 13.84886730144019, lng: 100.68349586891632 },
      ],
      doc: [
        {
          name: "สัญญาเช่า",
          url: "https://www.kanpho.go.th/new/images/formfood2/%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%87%E0%B8%AA%E0%B8%B7%E0%B8%AD%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B9%80%E0%B8%8A%E0%B9%88%E0%B8%B2_new.pdf",
        },
      ],
    },
    {
      name: "999/103",
      tenant: "นาย นันยศ กิตติยุต",
      address: "999/124 ABC-Road, PHUTO 99999",
      idcard: "1923333339992",
      tel: "0899114064",
      email: "Jimmy.c@gmail.com",
      rentalperiod: "2 year",
      price: "20000",
      paymentdeadline: "30-01-2023",
      lastpayment: "28-12-2022",
      status: "unpaid",
      water: {
        name: "Water Meter 999/103",
        position: { lat: 13.848718859801547, lng: 100.6836447315065 },
        meter: 7527,
      },
      electric: {
        name: "Electric Meter 999/103",
        position: { lat: 13.848731881001724, lng: 100.6836660038713 },
        meter: 4234,
      },
      path: [
        { name: "", lat: 13.848737089481583, lng: 100.68361790941819 },
        { name: "", lat: 13.848688911038408, lng: 100.68377347753047 },
        { name: "", lat: 13.848800893350413, lng: 100.68379761740997 },
        { name: "", lat: 13.848832144218553, lng: 100.6836353437756 },
      ],
      doc: [
        {
          name: "สัญญาเช่า",
          url: "https://www.kanpho.go.th/new/images/formfood2/%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%87%E0%B8%AA%E0%B8%B7%E0%B8%AD%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B9%80%E0%B8%8A%E0%B9%88%E0%B8%B2_new.pdf",
        },
      ],
    },
    {
      name: "999/104",
      tenant: "นางสาว กานต์พิชชา ภิญญาพัชญ์",
      address: "999/124 ABC-Road, PHUTO 99999",
      idcard: "1923333339992",
      tel: "0899114064",
      email: "Jimmy.c@gmail.com",
      rentalperiod: "2 year",
      price: "15000",
      paymentdeadline: "30-02-2023",
      lastpayment: "28-02-2023",
      status: "paid",
      water: {
        name: "Water Meter 999/104",
        position: { lat: 13.848854280247606, lng: 100.6831632750211 },
        meter: 7686,
      },
      electric: {
        name: "Electric Meter 999/104",
        position: { lat: 13.848825633621379, lng: 100.6832128958845 },
        meter: 4354,
      },
      path: [
        { name: "", lat: 13.848799591230827, lng: 100.68303587010156 },
        { name: "", lat: 13.848678494076403, lng: 100.68321826030217 },
        { name: "", lat: 13.848780059435994, lng: 100.68329067994064 },
        { name: "", lat: 13.848888135346808, lng: 100.68309890200912 },
      ],
      doc: [
        {
          name: "สัญญาเช่า",
          url: "https://www.kanpho.go.th/new/images/formfood2/%E0%B8%AB%E0%B8%99%E0%B8%B1%E0%B8%87%E0%B8%AA%E0%B8%B7%E0%B8%AD%E0%B8%AA%E0%B8%B1%E0%B8%8D%E0%B8%8D%E0%B8%B2%E0%B9%80%E0%B8%8A%E0%B9%88%E0%B8%B2_new.pdf",
        },
      ],
    },
    {
      name: "999/105",
      tenant: "-",
      address: "-",
      idcard: "-",
      tel: "-",
      email: "-",
      rentalperiod: "-",
      price: "9000",
      paymentdeadline: "-",
      lastpayment: "-",
      status: "Blank",
      water: {
        name: "Water Meter 999/105",
        position: { lat: 13.848761473029155, lng: 100.68331818064675 },
        meter: 4536,
      },
      electric: {
        name: "Electric Meter 999/105",
        position: { lat: 13.848735430630898, lng: 100.68335975488648 },
        meter: 1233,
      },
      path: [
        { name: "", lat: 13.848760170909305, lng: 100.6832900174521 },
        { name: "", lat: 13.848711992469973, lng: 100.68336780151353 },
        { name: "", lat: 13.84862605252638, lng: 100.68331281622872 },
        { name: "", lat: 13.848672928863191, lng: 100.68323369106278 },
      ],
      doc: [],
    },
    {
      name: "999/106",
      tenant: "-",
      address: "-",
      idcard: "-",
      tel: "-",
      email: "-",
      rentalperiod: "-",
      price: "9000",
      paymentdeadline: "-",
      lastpayment: "-",
      status: "Blank",
      water: {
        name: "Water Meter 999/106",
        position: { lat: 13.848698971268446, lng: 100.68341474017129 },
        meter: 7879,
      },
      electric: {
        name: "Electric Meter 999/106",
        position: { lat: 13.848684647945925, lng: 100.68346301993355 },
        meter: 4533,
      },
      path: [
        { name: "", lat: 13.84870938822974, lng: 100.68339194139466 },
        { name: "", lat: 13.848658605539054, lng: 100.68347508987412 },
        { name: "", lat: 13.848547925277346, lng: 100.68340267023072 },
        { name: "", lat: 13.848603916475154, lng: 100.68331147512421 },
      ],
      doc: [],
    },
    {
      name: "999/107",
      tenant: "-",
      address: "-",
      idcard: "-",
      tel: "-",
      email: "-",
      rentalperiod: "-",
      price: "9000",
      paymentdeadline: "-",
      lastpayment: "-",
      status: "Blank",
      water: {
        name: "Water Meter 999/107",
        position: { lat: 13.848679439464782, lng: 100.68351532300935 },
        meter: 7687,
      },
      electric: {
        name: "Electric Meter 999/107",
        position: { lat: 13.84866511614105, lng: 100.68357030829415 },
        meter: 1245,
      },
      path: [
        { name: "", lat: 13.848683345825641, lng: 100.6834885009192 },
        { name: "", lat: 13.848654699177771, lng: 100.68357701381669 },
        { name: "", lat: 13.848464589516102, lng: 100.68352739294991 },
        { name: "", lat: 13.848554435882448, lng: 100.68340267023072 },
      ],
      doc: [],
    },
  ]);

  const [zoneSelected, setZoneSelected] = React.useState(null);
  const [zoneSelectedIndex, setZoneSelectedIndex] = React.useState(null);
  const [zoneSelectedType, setZoneSelectedType] = React.useState(null);

  const [preExamDraw, setPreExamDraw] = React.useState([]);
  const [preExamDrawType, setPreExamDrawType] = React.useState(null);

  const [preExamPosition, setPreExamPosition] = React.useState(null);
  const [preExamPositionType, setPreExamPositionType] = React.useState(null);

  const [map, setMap] = React.useState(null);

  const prevMarkersRef = React.useRef([]);
  const prevPolygonsRef = React.useRef([]);
  const prevInfowindowRef = React.useRef([]);

  const onGetCenterFromBoundaries = (boundaries) => {
    let lat_sum = 0;
    let lng_sum = 0;

    for (let i = 0; i < boundaries.length; i++) {
      lat_sum += parseFloat(boundaries[i].lat);
      lng_sum += parseFloat(boundaries[i].lng);
    }

    let lat_center = lat_sum / boundaries.length;
    let lng_center = lng_sum / boundaries.length;

    return { lat: lat_center, lng: lng_center };
  };

  function createMarker(marker, map, color) {
    return new window.google.maps.Marker({
      position: marker.position,
      map: map,
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/" + color + "-dot.png",
      },
    });
  }

  function createPolygon(paths, map, color) {
    return new window.google.maps.Polygon({
      paths: paths,
      map: map,

      fillColor: color,
      fillOpacity: 0.1,
      strokeColor: color,
      strokeWeight: 2,
    });
  }

  function createPolyline(paths, map, color) {
    return new window.google.maps.Polyline({
      path: paths,
      map: map,

      strokeColor: color,
      strokeWeight: 10,
    });
  }

  function createExamMarker(marker, map, color) {
    console.log("createExamMarker");
    let label = marker.name.toString();
    return new window.google.maps.Marker({
      position: marker.position,
      map: map,
      label: { text: label, color: "#fff" },
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/" + color + "-dot.png",
      },
    });
  }

  function createExamPolyline(paths, map) {
    return new window.google.maps.Polyline({
      path: paths,
      map: map,

      strokeColor: "red",
      strokeWeight: 2,
    });
  }

  function clearMap(Ref) {
    for (let R of Ref) {
      R.setMap(null);
    }
  }

  const onWindowInfo = (anchor) => {
    clearMap(prevInfowindowRef.current);
    let position = anchor.position
      ? anchor.position
      : onGetCenterFromBoundaries(anchor.path);
    const infowindow = new window.google.maps.InfoWindow({
      content: anchor.name,
      position: position,
    });
    prevInfowindowRef.current.push(infowindow);
    infowindow.open({ map });
  };

  const onDrawMap = (map, markers, polygons) => {
    for (let i = 0; i < markers.length; i++) {
      let M = markers[i];
      const marker = createMarker(M, map, M.color);
      marker.addListener("click", () => {
        // console.log(M.name);
        clearMap(prevInfowindowRef.current);
        const infowindow = new window.google.maps.InfoWindow({
          content: M.name,
        });
        prevInfowindowRef.current.push(infowindow);
        infowindow.open({ anchor: marker, map });
        onVIewMeter(M.name, M.type);
      });
      prevMarkersRef.current.push(marker);
    }

    for (let i = 0; i < polygons.length; i++) {
      let P = polygons[i];
      const polygon = createPolygon(P.path, map, P.color);
      polygon.addListener("click", () => {
        // console.log(P.name);
        clearMap(prevInfowindowRef.current);
        const infowindow = new window.google.maps.InfoWindow({
          content: P.name,
          position: onGetCenterFromBoundaries(P.path),
        });
        prevInfowindowRef.current.push(infowindow);
        infowindow.open({ map });
        // panTo(P.path);
        if (P.name === "Main Area") {
          onNextTab(0);
        } else {
          onSelectedVIewZone(P.name);
        }
      });
      prevPolygonsRef.current.push(polygon);
    }
  };

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
    setTabSelected("");

    const bounds = new window.google.maps.LatLngBounds();
    mainAreaBoundaries[0].path.map((position) => bounds.extend(position));
    map.fitBounds(bounds);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const onRemovePreExamDrawByIndex = (index) => {
    let array = [...preExamDraw];
    array.splice(index, 1);
    setPreExamDraw(array);
  };

  const onRemoveZoneByIndex = (index) => {
    let array = [...zone];
    array.splice(index, 1);
    setZone(array);
  };

  const onFinishPreExamDraw = () => {
    if (preExamDrawType === "main-area") {
      let update_MainAreaBoundaries = [...mainAreaBoundaries];
      update_MainAreaBoundaries[0].path = [];

      for (let i = 0; i < preExamDraw.length; i++) {
        update_MainAreaBoundaries[0].path.push({
          name: preExamDraw[i].name,
          lat: preExamDraw[i].position.lat,
          lng: preExamDraw[i].position.lng,
        });
      }
      setMainAreaBoundaries(update_MainAreaBoundaries);
      panTo(update_MainAreaBoundaries[0].path);
    }

    if (preExamDrawType === "zone") {
      let updateZone = [...zone];
      let updateBoundary = [];
      for (let i = 0; i < preExamDraw.length; i++) {
        updateBoundary.push({
          name: preExamDraw[i].name,
          lat: preExamDraw[i].position.lat,
          lng: preExamDraw[i].position.lng,
        });
      }
      updateZone[zoneSelectedIndex].path = updateBoundary;
      setZone(updateZone);
      panTo(updateBoundary);
    }

    setPreExamDraw([]);
    onBackTab();
  };

  const onFinishPreExamPosition = () => {
    let updateZone = [...zone];
    updateZone[zoneSelectedIndex][preExamPositionType].position =
      preExamPosition.position;
    setZone(updateZone);
  };

  const onSelectedEditZone = (index) => {
    setZoneSelected(zone[index]);
    setZoneSelectedIndex(index);
    onWindowInfo(zone[index]);
    onNextTab("zone-edit");

    panTo(zone[index].path);
  };

  const onSelectedVIewZone = (zoneName) => {
    let indexZone = zone.findIndex((_zone) => _zone.name === zoneName);
    if (indexZone >= 0) {
      setZoneSelected(zone[indexZone]);
      setZoneSelectedIndex(indexZone);
      onNextTab("zone-view");

      panTo(zone[indexZone].path);
    }
  };

  const onVIewMeter = (zoneName, type) => {
    let indexZone = zone.findIndex((_zone) => _zone[type].name === zoneName);
    if (indexZone >= 0) {
      setZoneSelectedType(type);
      setZoneSelected(zone[indexZone]);
      setZoneSelectedIndex(indexZone);
      onNextTab("meter-view");
      panTo([zone[indexZone][type].position]);
    }
  };

  const handleSubmitFormEditZone = (e) => {
    e.preventDefault();
    // ???
    console.log(e);
    // console.log(e.target.elements.name.value) // from elements property
    console.log(e.target.name.value);
    console.log(e.target.tenant.value);
    onBackTab();
  };

  const panTo = (path) => {
    if (map) {
      const bounds = new window.google.maps.LatLngBounds();
      path.map((position) => bounds.extend(position));
      map.fitBounds(bounds);
    }
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  React.useEffect(() => {
    clearMap(prevMarkersRef.current);
    clearMap(prevPolygonsRef.current);

    if (TabSelected === "") {
      for (let i = 0; i < Tabs.length; i++) {
        if (
          map !== null &&
          Tabs[i].enable === true &&
          Tabs[i].name === "Main Area"
        ) {
          let markers = [];
          let polygons = [...mainAreaBoundaries];
          onDrawMap(map, markers, polygons);
        }

        if (
          map !== null &&
          Tabs[i].enable === true &&
          Tabs[i].name === "Zone"
        ) {
          let markers = [];
          let polygons = [];

          for (let j = 0; j < zone.length; j++) {
            let color_polygon =
              zone[j].status === "paid"
                ? "green"
                : zone[j].status === "unpaid"
                ? "red"
                : "darkgray";
            let polygon = {
              name: zone[j].name,
              path: zone[j].path,
              color: color_polygon,
            };
            polygons.push(polygon);
          }

          onDrawMap(map, markers, polygons);
        }

        if (
          map !== null &&
          Tabs[i].enable === true &&
          Tabs[i].name === "Water"
        ) {
          let markers = [];
          let polygons = [];

          for (let j = 0; j < zone.length; j++) {
            markers.push({ ...zone[j].water, color: "blue", type: "water" });
          }

          onDrawMap(map, markers, polygons);
        }

        if (
          map !== null &&
          Tabs[i].enable === true &&
          Tabs[i].name === "Electric"
        ) {
          let markers = [];
          let polygons = [];

          for (let j = 0; j < zone.length; j++) {
            markers.push({
              ...zone[j].electric,
              color: "yellow",
              type: "electric",
            });
          }

          onDrawMap(map, markers, polygons);
        }

        if (
          map !== null &&
          Tabs[i].enable === true &&
          Tabs[i].name === "Road"
        ) {
          // let polylines = {...roadBoundaries};

          for (let i = 0; i < roadBoundaries.length; i++) {
            let L = roadBoundaries[i];
            const polyline = createPolyline(L.path, map, L.color);
            polyline.addListener("click", () => {
              // console.log(P.name);
              clearMap(prevInfowindowRef.current);
              const infowindow_start = new window.google.maps.InfoWindow({
                content: "Start Main Road",
                position: L.path[0],
              });
              prevInfowindowRef.current.push(infowindow_start);
              infowindow_start.open({ map });

              const infowindow_end = new window.google.maps.InfoWindow({
                content: "End Main Road",
                position: L.path[L.path.length - 1],
              });
              prevInfowindowRef.current.push(infowindow_end);
              infowindow_end.open({ map });
              // panTo(P.path);
              // if (L.name === "Main Area") {
              //   onNextTab(0);
              // } else {
              //   onSelectedVIewZone(L.name);
              // }
            });
            prevPolygonsRef.current.push(polyline);
          }
        }
      }
    } else if (TabSelected === 0) {
      console.log("TabSelected === 0");
      let markers = [];
      // let polygons = mainAreaBoundaries;
      onDrawMap(map, markers, mainAreaBoundaries, "yellow");
    } else if (
      TabSelected === 1 ||
      TabSelected === "zone-edit" ||
      TabSelected === "add-position"
    ) {
      let markers_water = [];
      let markers_elect = [];
      let polygons = [];

      for (let j = 0; j < zone.length; j++) {
        let polygon = {
          name: zone[j].name,
          path: zone[j].path,
          color:
            (zone[j].status === "paid"
              ? "green"
              : zone[j].status === "unpaid"
              ? "red"
              : "darkgray"),
        };
        if (TabSelected === "zone-edit" || TabSelected === "add-position") {
          if (zoneSelectedIndex === j) {
            polygons.push(polygon);
            markers_water.push({
              ...zone[j].water,
              color: "blue",
              type: "water",
            });
            markers_elect.push({
              ...zone[j].electric,
              color: "yellow",
              type: "electric",
            });
          }
        } else {
          polygons.push(polygon);
          markers_water.push({
            ...zone[j].water,
            color: "blue",
            type: "water",
          });
          markers_elect.push({
            ...zone[j].electric,
            color: "yellow",
            type: "electric",
          });
        }
      }

      onDrawMap(map, [], polygons);
      onDrawMap(map, markers_water, []);
      onDrawMap(map, markers_elect, []);
    } else if (
      TabSelected === "zone-view" ||
      TabSelected === "meter-view" ||
      TabSelected === "tenant-view"
    ) {
      let markers_water = [];
      let markers_elect = [];
      let polygons = [];

      for (let j = 0; j < zone.length; j++) {
        let polygon = {
          name: zone[j].name,
          path: zone[j].path,
          color:
            zone[j].status === "paid"
              ? "green"
              : zone[j].status === "unpaid"
              ? "red"
              : "darkgray",
        };
        if (zoneSelectedIndex === j) {
          polygons.push(polygon);
          markers_water.push({
            ...zone[j].water,
            color: "blue",
            type: "water",
          });
          markers_elect.push({
            ...zone[j].electric,
            color: "yellow",
            type: "electric",
          });
        }
      }

      onDrawMap(map, [], polygons);
      onDrawMap(map, markers_water, []);
      onDrawMap(map, markers_elect, []);
    }
  }, [TabSelected, Tabs, zone, mainAreaBoundaries, roadBoundaries]);

  React.useEffect(() => {
    // clearMap(prevMarkersRef.current);
    // clearMap(prevPolygonsRef.current);

    if (map !== null && preExamDraw.length > 0) {
      let polyline_path = [];
      for (let i = 0; i < preExamDraw.length; i++) {
        let m = {
          name: i + 1,
          lat: preExamDraw[i].position.lat,
          lng: preExamDraw[i].position.lng,
        };

        const marker = createExamMarker(m, map, "yellow");
        prevMarkersRef.current.push(marker);

        polyline_path.push({
          lat: preExamDraw[i].position.lat,
          lng: preExamDraw[i].position.lng,
        });
      }

      const polyline = createExamPolyline(polyline_path, map);
      prevPolygonsRef.current.push(polyline);
    }

    if (map !== null && preExamPosition !== null) {
      let color =
        preExamPosition === "water"
          ? "blue"
          : preExamPosition === "electric"
          ? "yellow"
          : "green";
      const marker = createMarker(preExamPosition, map, color);
      prevMarkersRef.current.push(marker);
    }
  }, [preExamDraw, preExamPosition]);

  return (
    <div className="App">
      <div className="nav">
        <div className="title">GIS-DEMO</div>
        <div className="user-container">
          <div className="profile-img">A</div>
          <div className="name">Administrator</div>
        </div>
      </div>
      <div className="content">
        <div className="left-function">
          <div
            className={
              "tab-button-contrainer " + (TabSelected === "" ? "active" : "")
            }
          >
            {Tabs.map((tab, index) => {
              return (
                <div className="tab-button" key={index}>
                  <input
                    className="checkbox"
                    type="checkbox"
                    checked={Tabs[index].enable}
                    onChange={() => {
                      let _tabs = [...Tabs];
                      _tabs[index].enable = !Tabs[index].enable;
                      setTabs(_tabs);
                    }}
                  />
                  <div className="name" onClick={() => onNextTab(index)}>
                    {tab.name}
                  </div>
                </div>
              );
            })}
          </div>

          <div
            className={
              "tab-content-contrainer " + (TabSelected === 0 ? "active" : "")
            }
          >
            <div className="tab-content-button" onClick={() => onBackTab()}>
              BACK
            </div>
            <div className="tab-content-title">MAIN AREA</div>
            <div
              className="tab-content-button"
              onClick={() => {
                onNextTab("draw-area");
                setPreExamDrawType("main-area");
              }}
            >
              EDIT
            </div>
          </div>

          {/* <div
            className={
              "tab-content-contrainer " +
              (TabSelected === 1 ? "active" : "")
            }
          >
            <div className="tab-content-button" onClick={() => onBackTab()}>
              BACK
            </div>
            <div className="tab-content-title">ZONE</div>
            <div className="tab-content-button" onClick={() => onBackTab()}>
              INSERT
            </div>
            <div
              className="tab-content-button"
              onClick={() => onNextTab("zone-list")}
            >
              UPDATE
            </div>
          </div>

          <div
            className={
              "tab-content-contrainer " +
              (TabSelected === 2 ? "active" : "")
            }
          >
            <div className="tab-content-button" onClick={() => onBackTab()}>
              BACK
            </div>
            <div className="tab-content-title">WATER</div>
            <div className="tab-content-button" onClick={() => onBackTab()}>
              INSERT
            </div>
            <div className="tab-content-button" onClick={() => onBackTab()}>
              UPDATE
            </div>
          </div>

          <div
            className={
              "tab-content-contrainer " +
              (TabSelected === 3 ? "active" : "")
            }
          >
            <div className="tab-content-button" onClick={() => onBackTab()}>
              BACK
            </div>
            <div className="tab-content-title">ELECTRIC</div>
            <div className="tab-content-button" onClick={() => onBackTab()}>
              INSERT
            </div>
            <div className="tab-content-button" onClick={() => onBackTab()}>
              UPDATE
            </div>
          </div> */}

          <div
            className={
              "draw-contrainer " + (TabSelected === "draw-area" ? "active" : "")
            }
          >
            <div className="draw-contrainer-title">
              DRAW {preExamDrawType ? preExamDrawType.toUpperCase() : null}
            </div>
            <div className="draw-contrainer-subtitle">POSITION LIST</div>
            <div className="draw-contrainer-content">
              {preExamDraw.map((boundary, index) => {
                return (
                  <div
                    className="draw-contrainer-content-position-list"
                    key={index}
                  >
                    <div className="name">{boundary.name}</div>
                    <div className="position">{boundary.position.lat}</div>
                    <div className="position">{boundary.position.lng}</div>
                    <div
                      className="remove"
                      onClick={() => onRemovePreExamDrawByIndex(index)}
                    >
                      X
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="draw-contrainer-button-box">
              <div
                className="draw-contrainer-button"
                onClick={() => {
                  onBackTab();
                  setPreExamDrawType(null);
                  setPreExamDraw([]);
                }}
              >
                Cancel
              </div>
              <div
                className="draw-contrainer-button"
                onClick={() => {
                  onFinishPreExamDraw();
                }}
              >
                Finish
              </div>
            </div>
          </div>

          <div
            className={"draw-contrainer " + (TabSelected === 1 ? "active" : "")}
          >
            <div className="draw-contrainer-title">ZONE</div>
            <div className="draw-contrainer-subtitle">LIST OF ZONE</div>
            <div className="draw-contrainer-content">
              {zone.map((_zone, index) => {
                return (
                  <div
                    className="draw-contrainer-content-position-list"
                    key={index}
                  >
                    <div
                      className="name"
                      style={{ cursor: "pointer" }}
                      onClick={() => onSelectedEditZone(index)}
                    >
                      EDIT
                    </div>
                    <div
                      className="position"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        panTo(_zone.path);
                        onWindowInfo(_zone);
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>{_zone.name}</div>

                      {_zone.status === "paid" ? (
                        <span style={{ color: "green", width: 80 }}>PAID</span>
                      ) : _zone.status === "unpaid" ? (
                        <span style={{ color: "red", width: 80 }}>UNPAID</span>
                      ) : (
                        <span style={{ color: "darkgray", width: 80 }}>
                          BLANK
                        </span>
                      )}
                    </div>
                    <div
                      className="remove"
                      onClick={() => onRemoveZoneByIndex(index)}
                    >
                      X
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="draw-contrainer-button-box">
              <div
                className="draw-contrainer-button"
                onClick={() => onBackTab()}
              >
                Back
              </div>
            </div>
          </div>

          <div
            className={
              "draw-contrainer " + (TabSelected === "zone-edit" ? "active" : "")
            }
          >
            <div className="draw-contrainer-title">EDIT ZONE</div>
            <div className="draw-contrainer-subtitle"></div>
            {zoneSelected ? (
              <form
                className="draw-contrainer-content"
                onSubmit={(e) => {
                  handleSubmitFormEditZone(e);
                }}
              >
                <div className="scroll" style={{ flexGrow: 1 }}>
                  <div className="form-row">
                    <label className="toppic">Zone</label>
                    <input
                      className="value"
                      name="name"
                      type="text"
                      defaultValue={zoneSelected.name}
                    />
                  </div>
                  <div className="form-row">
                    <label className="toppic">Name</label>
                    <input
                      className="value"
                      name="tenant"
                      type="text"
                      defaultValue={zoneSelected.tenant}
                    />
                  </div>
                  <div className="form-row">
                    <label className="toppic">Address</label>
                    <input
                      className="value"
                      name="address"
                      type="text"
                      defaultValue={zoneSelected.address}
                    />
                  </div>
                  <div className="form-row">
                    <label className="toppic">ID card</label>
                    <input
                      className="value"
                      name="idcard"
                      type="text"
                      defaultValue={zoneSelected.idcard}
                    />
                  </div>
                  <div
                    className="button"
                    onClick={() => {
                      onNextTab("draw-area");
                      setPreExamDrawType("zone");
                    }}
                  >
                    Draw Zone Area
                  </div>
                  <label className="toppic">Water</label>
                  <div className="form-row">
                    <label className="toppic">Meter</label>
                    <input
                      className="value"
                      name="water_meter"
                      type="number"
                      defaultValue={zoneSelected.water.meter}
                    />
                  </div>
                  <div className="form-row">
                    <label className="toppic">Position</label>
                    <label
                      className="toppic"
                      style={{ fontWeight: "bolder", color: "darkcyan" }}
                    >
                      {zoneSelected.water.position.lat +
                        "\n" +
                        zoneSelected.water.position.lng}
                    </label>
                    <div
                      className="button"
                      onClick={() => {
                        onNextTab("add-position");
                        setPreExamPositionType("water");
                      }}
                    >
                      Edit
                    </div>
                  </div>
                  <label className="toppic">Electric</label>
                  <div className="form-row">
                    <label className="toppic">Meter</label>
                    <input
                      className="value"
                      name="electric_meter"
                      type="number"
                      defaultValue={zoneSelected.electric.meter}
                    />
                  </div>
                  <div className="form-row">
                    <label className="toppic">Position</label>
                    <label
                      className="toppic"
                      style={{ fontWeight: "bolder", color: "darkcyan" }}
                    >
                      {zoneSelected.electric.position.lat +
                        "\n" +
                        zoneSelected.electric.position.lng}
                    </label>
                    <div
                      className="button"
                      onClick={() => {
                        onNextTab("add-position");
                        setPreExamPositionType("electric");
                      }}
                    >
                      Edit
                    </div>
                  </div>
                  <div className="toppic">Document</div>
                  {zoneSelected.doc.map((doc, index) => {
                    return (
                      <div className="doc-list" key={index}>
                        <div
                          className="button"
                          onClick={() => {
                            openInNewTab(doc.url);
                          }}
                        >
                          Download
                        </div>
                        <label className="name">{doc.name}</label>
                        <div className="button" onClick={() => {}}>
                          Delete
                        </div>
                      </div>
                    );
                  })}
                  <div className="button" onClick={() => {}}>
                    Add Document
                  </div>
                </div>
                <div className="form-row" style={{ height: 30 }}>
                  <input
                    className="button"
                    style={{ height: "100%" }}
                    type="button"
                    onClick={() => {
                      onBackTab();
                      setZoneSelected(null);
                    }}
                    value="Cancel"
                  ></input>
                  <input
                    className="button"
                    style={{ height: "100%" }}
                    type="submit"
                    value="Finish"
                  />
                </div>
              </form>
            ) : null}
          </div>

          <div
            className={
              "draw-contrainer " +
              (TabSelected === "add-position" ? "active" : "")
            }
          >
            <div className="draw-contrainer-title">
              SELECT{" "}
              {preExamPositionType ? preExamPositionType.toUpperCase() : null}{" "}
              POSITION
            </div>
            <div className="draw-contrainer-subtitle"></div>
            <div className="draw-contrainer-content">
              <div className="toppic">
                Old {preExamPositionType ? preExamPositionType : null} Position
              </div>
              <div
                className="position"
                style={{ fontWeight: "bolder", color: "darkcyan" }}
              >
                {preExamPositionType
                  ? zoneSelected[preExamPositionType].position.lat +
                    "\n" +
                    zoneSelected[preExamPositionType].position.lng
                  : null}
              </div>
              <div className="toppic">
                New {preExamPositionType ? preExamPositionType : null} Position
              </div>
              <div
                className="position"
                style={{ fontWeight: "bolder", color: "darkcyan" }}
              >
                {preExamPosition
                  ? preExamPosition.position.lat +
                    "\n" +
                    preExamPosition.position.lng
                  : null}
              </div>
            </div>
            <div className="draw-contrainer-button-box">
              <div
                className="draw-contrainer-button"
                onClick={() => {
                  onBackTab();
                  setPreExamPosition(null);
                  setPreExamPositionType(null);
                }}
              >
                Cancel
              </div>
              <div
                className="draw-contrainer-button"
                onClick={() => {
                  onBackTab();
                  onFinishPreExamPosition();
                }}
              >
                Finish
              </div>
            </div>
          </div>

          <div
            className={
              "draw-contrainer " + (TabSelected === "zone-view" ? "active" : "")
            }
          >
            <div className="draw-contrainer-title">ZONE</div>
            <div className="draw-contrainer-subtitle"></div>

            {zoneSelected ? (
              <div className="draw-contrainer-content">
                <div className="scroll" style={{ flexGrow: 1 }}>
                  <div className="form-row-view">
                    <label className="toppic">Zone Name</label>
                    <div className="value">{zoneSelected.name}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Tenant name</label>
                    <div className="value">{zoneSelected.tenant}</div>
                    <div
                      className="button"
                      onClick={() => onNextTab("tenant-view")}
                    >
                      Detail
                    </div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Water Meter</label>
                    <div className="value">{zoneSelected.water.meter}</div>
                    <div
                      className="button"
                      onClick={() => {
                        onWindowInfo(zoneSelected.water);
                        onVIewMeter(zoneSelected.water.name, "water");
                      }}
                    >
                      Detail
                    </div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Electric Meter</label>
                    <div className="value">{zoneSelected.electric.meter}</div>
                    <div
                      className="button"
                      onClick={() => {
                        onWindowInfo(zoneSelected.electric);
                        onVIewMeter(zoneSelected.electric.name, "electric");
                      }}
                    >
                      Detail
                    </div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Rental Period</label>
                    <div className="value">{zoneSelected.rentalperiod}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Price/month</label>
                    <div className="value">{zoneSelected.price}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Payment Deadline</label>
                    <div className="value">{zoneSelected.paymentdeadline}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Last Payment</label>
                    <div className="value">{zoneSelected.lastpayment}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Status</label>
                    <div className="value">
                      {zoneSelected.status === "paid" ? (
                        <span style={{ color: "green" }}>PAID</span>
                      ) : zoneSelected.status === "unpaid" ? (
                        <span style={{ color: "red" }}>UNPAID</span>
                      ) : (
                        <span style={{ color: "darkgray" }}>BLANK</span>
                      )}
                    </div>
                  </div>
                  <div className="toppic">Document</div>
                  {zoneSelected.doc.map((doc, index) => {
                    return (
                      <div className="doc-list" key={index}>
                        <div
                          className="button"
                          onClick={() => {
                            openInNewTab(doc.url);
                          }}
                        >
                          Download
                        </div>
                        <label className="name">{doc.name}</label>
                        <div className="button" onClick={() => {}}>
                          Delete
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="form-row" style={{ height: 30 }}>
                  <input
                    className="button"
                    style={{ height: "100%" }}
                    type="button"
                    onClick={() => {
                      onBackTab();
                    }}
                    value="Back"
                  ></input>
                </div>
              </div>
            ) : null}
          </div>

          <div
            className={
              "draw-contrainer " +
              (TabSelected === "meter-view" ? "active" : "")
            }
          >
            {zoneSelected && zoneSelectedType ? (
              <div className="draw-contrainer-title">
                METER {zoneSelectedType.toUpperCase()} ZONE{" "}
                {zoneSelected.name.toUpperCase()}
              </div>
            ) : null}
            <div className="draw-contrainer-subtitle"></div>
            <div className="draw-contrainer-content">
              <div className="scroll" style={{ flexGrow: 1 }}>
                {zoneSelectedType && zoneSelectedType === "electric" ? (
                  <>
                    <img alt="ImgMockup1" src={ImgMockup1} />
                    <img alt="ImgMockup2" src={ImgMockup2} />
                  </>
                ) : (
                  <>
                    <img alt="ImgMockup3" src={ImgMockup3} />
                    <img alt="ImgMockup4" src={ImgMockup4} />
                  </>
                )}
              </div>
            </div>
            <div className="draw-contrainer-button-box">
              <div
                className="draw-contrainer-button"
                onClick={() => {
                  onBackTab();
                }}
              >
                BACK
              </div>
            </div>
          </div>

          <div
            className={
              "draw-contrainer " +
              (TabSelected === "tenant-view" ? "active" : "")
            }
          >
            <div className="draw-contrainer-title">TENANT DETAIL</div>
            <div className="draw-contrainer-subtitle"></div>

            {zoneSelected ? (
              <div className="draw-contrainer-content">
                <div className="scroll" style={{ flexGrow: 1 }}>
                  <div className="form-row-view">
                    <label className="toppic">Name</label>
                    <div className="value">{zoneSelected.tenant}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Address</label>
                    <div className="value">{zoneSelected.address}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">ID Card</label>
                    <div className="value">{zoneSelected.idcard}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Tel</label>
                    <div className="value">{zoneSelected.tel}</div>
                  </div>
                  <div className="form-row-view">
                    <label className="toppic">Email</label>
                    <div className="value">{zoneSelected.email}</div>
                  </div>
                </div>
                <div className="form-row" style={{ height: 30 }}>
                  <input
                    className="button"
                    style={{ height: "100%" }}
                    type="button"
                    onClick={() => {
                      onBackTab();
                    }}
                    value="Back"
                  ></input>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="map-container">
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={{ width: "100%", height: "100%" }}
              // center={14.036464636542759, 100.46437004234423}
              // zoom={zoom}
              onLoad={onLoad}
              onUnmount={onUnmount}
              onClick={(ev) => {
                console.log({
                  lat: ev.latLng.lat(),
                  lng: ev.latLng.lng(),
                });
                if (TabSelected === "draw-area") {
                  let updateDraw = [
                    ...preExamDraw,
                    {
                      name: preExamDraw.length + 1,
                      position: {
                        lat: ev.latLng.lat(),
                        lng: ev.latLng.lng(),
                      },
                    },
                  ];
                  setPreExamDraw(updateDraw);
                }

                if (TabSelected === "add-position") {
                  let updateDraw = {
                    name: "",
                    position: {
                      lat: ev.latLng.lat(),
                      lng: ev.latLng.lng(),
                    },
                  };
                  setPreExamPosition(updateDraw);
                }
              }}
            ></GoogleMap>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default App;
